import React, { useEffect, useRef, useState } from 'react';
import useLatest from '../hooks/useLatest';
import createAnforaFallback from './createAnforaFallback';
import anforaFrente from '../assets/images/anfora-3d-frente.webp';

// El ánfora en los equipos sin WebGL con aceleración gráfica: la misma secuencia del 3D dibujada en un canvas 2D. Avisa
// con onStart cuando empieza a moverse, como AnforaAnimate. Si el navegador tampoco tiene canvas 2D queda la imagen fija.
export default function AnforaFallback({ durationMs, error, onStart }) {
  const canvas = useRef(null);
  const latest = useLatest({ error, onStart });
  const [canDraw] = useState(() => Boolean(document.createElement('canvas').getContext('2d')));

  useEffect(() => {
    if (!canDraw) return undefined;
    return createAnforaFallback(canvas.current, {
      durationMs,
      isError: () => Boolean(latest.current.error),
      onStart: () => latest.current.onStart?.(),
    }) || undefined;
  }, [canDraw, durationMs, latest]);

  if (!canDraw) {
    return <img src={anforaFrente} alt="anfora" onLoad={onStart}
      style={{ paddingTop: '2rem', width: '45vw', maxHeight: '100%', objectFit: 'contain' }} />;
  }
  return <canvas ref={canvas} data-testid="anfora-2d" aria-label="Ánfora girando mientras se busca al ganador"
    style={{ display: 'block', width: '100%', height: '100%' }} />;
}
